import {measureService} from '../index'
import {MeasureTypes} from './MeasureService'

class FormattingService {
    static formatNumber(value: number) {
        return value.toLocaleString(FormattingService._getLocale())
    }

    static formatDate(value: Date, options?: Intl.DateTimeFormatOptions) {
        return value.toLocaleDateString(FormattingService._getLocale(), options)
    }

    private static _getLocale() {
        return measureService.currentMeasure === MeasureTypes.Imperial ? 'en-US' : 'de-CH'
    }
}

export default FormattingService
